import ShareBringNewFansBody from "../ShareBringNewFansBody";
import { useTranslation } from "react-i18next";

const MyProfileBody = () => {
  const { t } = useTranslation("modals");
  return (
    <div className="d-flex justify-content-center text-body-1 text-regular text-primary mb-4">
      {t("SHARE_YOUR_LINK")}
    </div>
  );
};

const defaultContent = (props) => {
  return {
    body: (
      <ShareBringNewFansBody
        {...props}
        leftText="SHARE_BRING_NEW_FANS_TITLE"
        leftTextParams={{ username: props?.username }}
        rightText="EARN_TITLE"
        rightTextParams={{ username: props?.username }}
      />
    ),
    titleKey: "SHARE_BRING_NEW_FANS_MODAL_TITLE",
    titleParams: { username: props?.username },
  };
};

const getContent = (props) => {
  return {
    profile: {
      me: {
        body: <MyProfileBody />,
        titleKey: "SHARE_TITLE_SHORT",
      },
      default: defaultContent(props),
    },
    post: {
      me: {
        body: <MyProfileBody />,
        titleKey: "SHARE_TITLE_SHORT",
      },
      default: defaultContent(props),
    },
    subscription: {
      me: {
        body: <MyProfileBody />,
        titleKey: "SHARE_TITLE_SHORT",
      },
      default: defaultContent(props),
    },
    stream: {
      default: {
        titleKey: "SHARE_STREAM",
      },
    },
    streamDetails: {
      default: {
        titleKey: "SHARE_STREAM",
      },
    },
    default: defaultContent(props),
  };
};

const useShareContent = ({
  type,
  isMyProfile,
  withBody,
  username,
  shareLink,
}) => {
  const isMyProfileKey = isMyProfile ? "me" : "default";

  const content = getContent({ username, shareLink });
  const body = content[type]
    ? content[type][isMyProfileKey]?.body
    : content?.default?.body;

  const titleKey = withBody
    ? content?.[type]?.[isMyProfileKey]?.titleKey || "SHARE_TITLE"
    : "SHARE_TITLE_SHORT";
  const titleParams = content?.[type]?.[isMyProfileKey]?.titleParams;
  return {
    body,
    titleKey,
    titleParams,
  };
};

export default useShareContent;
